<div class="card bg-base-100 w-full">
  <ul class="menu menu-lg md:menu-vertical w-full gap-4 px-4">
    <li>
      <a routerLink="/dashboard" routerLinkActive="menu-active">
        <ng-icon name="lucideChartColumn"></ng-icon>
        {{ "navigation.menu.dashboard" | translate }}
      </a>
    </li>
    <li>
      <a routerLink="/courses" routerLinkActive="menu-active">
        <ng-icon name="lucideBookOpenText"></ng-icon>
        {{ "navigation.menu.courses" | translate }}
      </a>
    </li>
    <li>
      <a routerLink="/instructions" routerLinkActive="menu-active">
        <ng-icon name="lucideListChecks"></ng-icon>
        {{ "navigation.menu.instructions" | translate }}
      </a>
    </li>
    <li>
      <a routerLink="/information" routerLinkActive="menu-active">
        <ng-icon name="lucideInfo"></ng-icon>
        {{ "navigation.menu.information" | translate }}
      </a>
    </li>
    <li>
      <a routerLink="/settings" routerLinkActive="menu-active">
        <ng-icon name="lucideSettings"></ng-icon>
        {{ "navigation.menu.settings" | translate }}
      </a>
    </li>
  </ul>
</div>
